const q_ricambi = {
  placeholder: 'Sezione in costruzione',
  steps: {
    form: 'Dati',
    result: 'Riepilogo',
  },
  date_label: 'Dati QR',
  groups: 'Selezione gruppi',
  brands: 'Selezione brand Cati',
  classes: 'Selezione classi',
  product_id: 'Product ID',
  cati_code: 'Codice Cati',
  class_code: 'Codice classe',
  supplier_code_1: 'Codice Fornitore 1',
  supplier_code_2: 'Codice Fornitore 2',
  manufacturer_name: 'Produttore',
  dataset_label: 'Dataset',
  dataset_cati: 'CATI',
  dataset_qricambi: 'QRicambi',
  dataset_cati_qricambi: 'CATI+QRicambi',
  cati_columns_label: 'Seleziona colonne CATI',
  qricambi_columns_label: 'Seleziona colonne QRicambi',
  cross: 'Cross',
}

export default q_ricambi
